import { render, staticRenderFns } from "./process_item_base.vue?vue&type=template&id=497f57ae&scoped=true"
import script from "./process_item_base.vue?vue&type=script&lang=js"
export * from "./process_item_base.vue?vue&type=script&lang=js"
import style0 from "./process_item_base.vue?vue&type=style&index=0&id=497f57ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497f57ae",
  null
  
)

export default component.exports